<script>
import Service from '../../services/jetty';
import CommonService from '../../services/common';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import config from '../../common/genericPanelConf';

import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';

import GenericDataTable from '../../components/generic/GenericDataTable.vue'
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

export default{
  components: {
    InputText,
    GenericDataTable,
    GenericCustomAutocompleteV2,
    Checkbox,
    ResponsiveButton
},
  data(){
    return {
      header: {
        vesselName: '',
        masterOfVessel: ''
      },
      timesheet: {voyageNumber: null},
      timesheetConfiguration: {},
      onlyOpened: true,
      filteredOperations: [],
      includePrivate: true
    }
  },
  computed: {
    constants(){
      return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
    
  },
  created(){
    this.timesheetConfiguration = config.getConfiguration('Timesheet');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'timesheet.page_title');
    if(this.$route.query.defaultVoyageNumber){
      this.timesheet.voyageNumber = this.$route.query.defaultVoyageNumber;
      this.onlyOpened = this.$route.params.onlyOpened == 'false' ? false : true;
    }
  },
  watch: {
    header() {
      this.loadGrid();
    },
  },
  methods: {
    loadGrid() {
      let filters = [];
      filters.push({
          operator: 'eq',
          value: this.header.id,
          property: 'IdJettyVesselTimesheetHeader'
      });
      filters.push({
          operator: 'eq',
          value: false,
          property: 'IsCancelled'
      });
      this.$refs.timesheetGrid.filterFromView(filters);
    },
    onVoyageSelected(event){
      if (event.value) {
        this.getTimesheetHeader(event.value.extraData, event.value.value);
      }
    },
    onEventSelected(event) {
      const body = {
        idJettyVesselTimesheetHeader: this.header.id,
        idRegistryTimesheetOperation: event.value.value,
        registryTimesheetOperationDescription: event.value.label
      }
      Service.createTimesheetDetail(body, ({success, message}) => {
        this.loadGrid(); 
        this.addToast(success, message)
      })
    },
    updateMaster() {
      const data = {
        ...this.header,
        masterOfVessel: this.header.masterOfVessel
      }
      this.updateTimesheetHeader(data);
    },
    updateToast(success, message) {
      if(success){
        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
      }else{
        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
      }
    },
    addToast(success, message){
      if(success){
        if(message){
          this.$toast.add({severity:'warn', summary: 'Warning Message', detail: 'Item created but ' + message, life: 3000});
        }else{
          this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
        }
      }else{
        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
      }
    },
    getTimesheetHeader(voyageNumber, id){
      Service.getTimesheetHeader(voyageNumber, ({data, success, message, notFound}) => {
        if(success){
          if(data){
            this.header = data;
            CommonService.loadGeneric('masterdata/timesheet-operation-combo',{getOnlyValid: true, chargeDischargeFlag: this.header.chargeDischargeFlag}, ({success, data}) => {
              if(success){
                this.filteredOperations = data;
              }else{
                this.filteredOperations = [];
              }
            })
          }
        }else{
          if(notFound){
            this.createTimesheetHeader(id);
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        }
        // (this.header = data || { vesselName: '', masterOfVessel: ''})
      })
    },
    updateTimesheetHeader(data) {
      CommonService.updateItem('jetty/vessel-timesheet-header', data, ({success, message}) => {this.loadGrid(); this.updateToast(success, message)})
    },
    onCellEditComplete(event){
      if (event.data[event.field] != event.newValue) {
        this.updateTimesheetDetails(event.newData);
      }
    },
    updateTimesheetDetails(data) {
      CommonService.updateItem(this.timesheetConfiguration.updateApi, data, ({success, message}) => {this.loadGrid(); this.updateToast(success, message); 
      this.$refs.timesheetGrid.hideDialogEdit();})
    },
    createTimesheetHeader(id){
        Service.createTimesheetHeader({key: id}, ({success, data, message}) => {
          if(success){
            this.header = data;
            Service.createTimesheetMandatory({key: data.id}, ({success, message}) => {
              if(success){
                this.loadGrid();
                this.addToast(success, message)
              }else{
                this.addToast(success, message)
              }
            })
          }else{
            this.addToast(success, message)
          }
        })
    },
    printPdf(){
      let params = {
          id: this.header.id,
          isPrivate: this.includePrivate
      };
      this.$store.dispatch("generic/setLoading", true);
      Service.printTimesheet(params, response => {
          
          this.$store.dispatch("generic/setLoading", false);
          if(response.success){
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
          
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Timesheet_' + this.timesheet.voyageNumber + '.pdf');
              document.body.appendChild(fileLink);
          
              fileLink.click();
          }else{
              this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
      })
    },
    onTimesheetEditSave(editItem){
      this.updateTimesheetDetails(editItem);
    }
  }
}

</script>

<template>
  <main>
    <div class="m-5">
      <div class="grid">
        <div class="col-12 lg:col-3 field">
          <label for="voyages">{{$t('timesheet.voyage')}}</label>
          <GenericCustomAutocompleteV2
            :onItemSelect="onVoyageSelected"
            v-model="timesheet.voyageNumber"
            name="voyages" 
            id="voyages"
            :queryField="{getOnlyOpened: onlyOpened, transportType: 'N,B'}"
            :format="{ label: 'label', value: 'extraData' }"
            api="movement-instruction/voyage-number-combo"
            class="w-full p-inputtext-sm" />
            <div>
              <Checkbox
              v-model="onlyOpened" 
              :binary="true" 
              name="onlyOpened"
              class="mt-2 mr-2"/>
              <label for="onlyOpened">{{$t('timesheet.onlyOpenedVoyage')}}</label>  
            </div>
        </div>
        <div class="col-12 lg:col-3 field">
          <label for="vesselName">{{$t('timesheet.vessel')}}</label>
          <InputText id="vesselName" type="text" disabled="true" v-model="header.vesselName" class="w-full p-inputtext-sm m-1" />
        </div>
        <div class="col-12 lg:col-3 field">
          <label for="masterOfVessel">{{$t('timesheet.masterOfVessel')}}</label>
          <InputText 
            id="masterOfVessel"
            :disabled="!header.id"
            @keyup.enter="updateMaster"
            @focusout="updateMaster"
            type="text"
            v-model="header.masterOfVessel" 
            class="w-full p-inputtext-sm m-1" />
        </div>
        <div class="col-12 lg:col-3 field">
          <div class="p-4">
          <ResponsiveButton :label="$t('btn.print')" icon="pi pi-file-pdf" class="p-button-info p-button-sm mt-2 mr-2" @click="printPdf" :disabled="!header.id"/>
          <Checkbox
              v-model="includePrivate" 
              :binary="true" 
              name="includePrivate"
              class="mt-2 mr-2"/>
              <label for="includePrivate">{{$t('timesheet.includePrivate')}}</label> 
          </div>
        </div>
        <div class="col-12 field">
          <label for="operations">{{$t('timesheet.operations')}}</label>
          <GenericCustomAutocompleteV2
            v-if="uiPermissions('Jetty.TimesheetAddDetail').isEnabled"
            :onItemSelect="onEventSelected"
            v-model="timesheet.idEvent"
            name="operations" 
            :format="{ label: 'label', value: 'value' }"
            :staticOptions="filteredOperations"
            class="w-full p-inputtext-sm" />
        </div>
        <div class="col-12">
          <GenericDataTable :configuration="timesheetConfiguration" :category="'timesheet'" :name="'timesheet'" ref="timesheetGrid" :onDialogEditSave="onTimesheetEditSave" />
        </div>
      </div>
    </div>
  </main>
</template>
